// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import type { InlineRichText } from '../../internal/types';
import PageContentBlock from '../../internal/PageContentBlock';
import FormattedContent from '../../internal/FormattedContent';
import ResponsiveImage from '../../internal/ResponsiveImage';
import { Columns } from '../../internal/Columns';

type PropTypes = {|
  title: string,
  message: InlineRichText,
  image: string,
  alt?: string,
  nextStepsTitle: string,
  nextSteps: Array<{|
    icon: string,
    content: InlineRichText,
  |}>,
|};

export default (props: PropTypes) => {
  return (
    <>
      <PageContentBlock>
        <div className={styles.imageContainer}>
          <ResponsiveImage
            className={styles.image}
            src={props.image}
            alt={props.alt}
            defaultSize={{ width: 550 }}
          />
        </div>
        <h1 className={styles.title}>{props.title}</h1>
        <p className={styles.description}>
          <FormattedContent>{props.message}</FormattedContent>
        </p>
      </PageContentBlock>
      <PageContentBlock intro={props.nextStepsTitle} background="DefaultContrast">
        <Columns columns={3} centerColumns>
          {props.nextSteps.map(step => (
            <div>
              <div className={styles.step}>
                <ResponsiveImage
                  className={styles.icon}
                  src={step.icon}
                  alt=""
                  defaultSize={{ width: 45, height: 45 }}
                />
                <p className={styles.stepText}>
                  <FormattedContent>{step.content}</FormattedContent>
                </p>
              </div>
            </div>
          ))}
        </Columns>
      </PageContentBlock>
    </>
  );
};
